"use strict";
import React from "react";
import { emailService } from "../services/email_service";
import WaitingSpinner from "../components/waiting_spinner";
var CloseReply = React.createClass({
  getInitialState: function() {
    return {
      closingReply: false
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      WaitingSpinner,
      {
        when: this.state.closingReply,
        "data-component": "CloseReply"
      },
      /* @__PURE__ */ React.createElement("button", { className: "button--progress", onClick: this.closeReply }, "Close Reply")
    );
  },
  closeReply: function() {
    emailService.markComplete(null, false, this.props.emailId).then(() => {
      this.props.onComplete();
    });
  }
});
export default CloseReply;
